// Copyright (c) Meta Platforms, Inc. and affiliates.

'use client';

/**
 * @file index.ts
 * @input Imports from ButtonGroup.tsx and ButtonGroupContext.ts
 * @output Exports ButtonGroup, context hook, and types
 * @position Component entry point; re-exported by /packages/core/src/index.ts
 */
export { ButtonGroup } from "./ButtonGroup.js";
export { useButtonGroup } from "./ButtonGroupContext.js";